import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'react-feather';
import { Chip } from '@mui/material';

export const StatusChip = ({
  status,
  label,
}: {
  status: 'success' | 'warning' | 'error';
  label: string;
}) => {
  const getColor = () => {
    switch (status) {
      case 'success':
        return 'success';
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      default:
        return 'default';
    }
  };

  const getIcon = () => {
    switch (status) {
      case 'success':
        return <CheckCircle size={16} />;
      case 'warning':
        return <AlertTriangle size={16} />;
      case 'error':
        return <XCircle size={16} />;
      default:
        return <></>;
    }
  };
  const color = getColor();
  const icon = getIcon();

  return (
    <Chip
      label={label}
      color={color}
      variant="outlined"
      icon={icon}
      size="small"
    />
  );
};
